import { render, staticRenderFns } from "./PublicationsList.vue?vue&type=template&id=7b0ef5da&"
import script from "./PublicationsList.vue?vue&type=script&lang=js&"
export * from "./PublicationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports